import moment from "moment-timezone";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../Auth/AuthContext";
import RqContext from "../Request/RqContext";
import CountryContext from "./CountryContext";

const CountryState = ({ children }) => {
  const { requestGET } = useContext(RqContext);
  const { profile } = useContext(AuthContext);
  // Primitive string (or null) — safe as a dependency; re-triggers on login without loop.
  const countryID = profile?.company?.countryID || null;

  const [country, setCountry] = useState(null);
  const [zone, setZone] = useState(null);
  const [status, setStatus] = useState("idle");
  // Incrementing key re-fires the resolution on manual retry.
  const [fetchKey, setFetchKey] = useState(0);

  useEffect(() => {
    if (!countryID) {
      setStatus("idle");
      return;
    }
    setStatus("loading");
    requestGET({
      gateway: "no-auth",
      fun: "getCountries",
      json: { type: "all" },
      save: (list) => {
        if (!Array.isArray(list)) {
          setStatus("failed");
          return;
        }
        const row = list.find((c) => c.uniqueID === countryID);
        if (!row) {
          setStatus("failed");
          return;
        }
        const tz = row.timeZone;
        if (!tz || moment.tz.zone(tz) === null) {
          // timeZone present but not a valid IANA zone
          setCountry(row);
          setZone(null);
          setStatus("failed");
          return;
        }
        setCountry(row);
        setZone(tz);
        setStatus("ok");
      },
    });
  // requestGET is stable from RqContext but excluded to avoid triggering on every RqState render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryID, fetchKey]);

  const retry = () => setFetchKey((k) => k + 1);

  return (
    <CountryContext.Provider value={{ country, zone, status, retry }}>
      {children}
    </CountryContext.Provider>
  );
};

export default CountryState;
